

<script>
/*jshint esversion: 6 */ 
import {watch, computed, inject} from 'vue';
import './../func.common';
import { FontAwesomeIcon, FontAwesomeLayers} from "@fortawesome/vue-fontawesome";
export default {
    name: 'FurtherJobs',
    components: {
        'font-awesome-icon' : FontAwesomeIcon,
        'font-awesome-layers' : FontAwesomeLayers,
    },
    props: {
		'hinted': {type:String},
        'disabled': {type: Boolean},
        'fullSchema': { type: [Object], default: function() { return {};} }, 
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    setup(props) {
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(() => helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator,
                'vTxext': props.schema.validatorText
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }, {deep:true});


        function addJob() {
            props.model[props.schema.model].push(['','']);
        }

        function deleteJob(index) {
            props.model[props.schema.model].splice(index,1);
        }

        return {
            addJob, 
            deleteJob, 
        }
    }
}
</script>
<template lang="pug">
.vueFormFieldMain
    .jobSectorMain(
        :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        label(v-if="schema.label" v-html="schema.label")
        template(v-for="item, index in model[schema.model]")
            .row.align-items-start
                .col-12( :style="disabled === true ? 'cursor: not-allowed; opacity: 0.5' : ''") 
                        label {{ index+1 }}. weiterer Ausbildungsberuf
                .justify-content-between.col-12
                    .inputField(:class="schema.direction === 'horizontical' ? 'col-6': 'col-12'")
                        .fullField.fieldInput.col-12( :style="disabled === true ? 'cursor: not-allowed; opacity: 0.5' : ''")
                            input.form-control(
                                :id="id" 
                                :type="schema.inputType" 
                                :name="schema.model" 
                                :value="item[0]" 
                                v-model="item[0]" 
                                placeholder="Sparte"
                                maxlength="255"
                                :style="[disabled === true ? 'pointer-events:none' : '']"
                            )
                    .inputField(:class="schema.direction === 'horizontical' ? 'col-6': 'col-12'")  
                        .fullField.fieldInput.col-12(
                            :style="[item[0].length < 1 ? 'cursor: not-allowed; opacity: 0.5' : '', disabled === true ? 'cursor: not-allowed; opacity: 0.5' : '']"
                        )   
                            input.form-control(
                                :id="id" 
                                :type="schema.inputType" 
                                :name="schema.model" 
                                :value="item[1]" 
                                v-model="item[1]" 
                                placeholder="Ausbildungsberuf"
                                maxlength="255"
                                :style="[item[0].length < 1 ? 'pointer-events:none' : '', disabled === true ? 'pointer-events:none' : '']"
                            ) 
                .row.align-items-end.justify-content-end.col-12(v-if="!disabled")
                    .col-1.plusButton(
                        v-if="(index+1 === model[schema.model].length) && (item[0].length > 0 && item[1].length > 0)"
                        @click="addJob()")
                        .row.align-items-end.justify-content-end
                            .col-2
                                font-awesome-layers.fa-lg.setPlus
                                    font-awesome-icon(icon="fa-solid fa-plus"  transform="shrink-7")
                                    font-awesome-icon(icon="fa-regular fa-circle")
                    .col-1.minusButton(@click="deleteJob(index)" v-if="index > 0")
                        .row.align-items-end.justify-content-end
                            .col-2
                                font-awesome-layers.fa-lg.setMinus
                                    font-awesome-icon(icon="fa-solid fa-minus"  transform="shrink-7")
                                    font-awesome-icon(icon="fa-regular fa-circle") 
        .form-group.row.gy-2.gx-3-align-items-left
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
            .vueFormSmall.labelred(v-if="schema.errorShow === true")
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                | &nbsp;{{ schema.errorText[0] }}
</template>    